import ActionsButton from "./ActionButton";

const AboutUsHeroSection = () => {
  return (
    <section className=" container   space-y-8 mx-auto mt-[140px] md:mt-[210px] lg:mt-[250px]">
      <div className=" space-y-1 ">
        <h4 className="font-bold  text-light text-[12px]  leading-[33px] text-center ">
          About US
        </h4>
        <div className="space-y-4">
          <h1 className="  feat-head-m md:feat-head-t xl:feat-head-d ">
            Artificial Intelligence Shapes the Future{" "}
            <span className="text-[#433CAE] block sm:inline-block">
              {" "}
              - We Lead the Way
            </span>
          </h1>
          <p className="!text-[#6D6D6D] max-w-[1020px] mx-auto  text-center  lg:text-[21px] text-lg   font-medium   ">
            At Raadco, we specialise in developing and maintaining AI systems
            that make businesses smarter, faster, and stronger. From vision to
            execution, we’re your partner in innovation.
          </p>
        </div>
      </div>
      <ActionsButton />
    </section>
  );
};

export default AboutUsHeroSection;
